import { render, staticRenderFns } from "./IconBehance.vue?vue&type=template&id=9fd77e6e&"
import script from "./IconBehance.vue?vue&type=script&lang=js&"
export * from "./IconBehance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports